import ongs from "./ongs";
import brand from "./brand";

export const apiOngs = ongs;
export const apiBrand = brand;
